<ng-container *ngFor="let menu of filteredNodes">
    @if(menu.onClick) {
    <button mat-button (click)="menu.onClick()">{{menu.name | translate }}</button>
    } @else if(menu.route) {
    <button mat-button [routerLink]="menu.route">{{menu.name | translate }}</button>
    }@else if(menu.url) {
    <a mat-button [href]="menu.url">{{menu.name | translate }}</a>
    } @else {
    <button mat-button [matMenuTriggerFor]="submenu">{{menu.name | translate }}</button>
    }

    <mat-menu #submenu="matMenu" class="sub-menu">
        <app-menu-item *ngFor="let item of menu.children" [item]="item" [fromSide]="true"></app-menu-item>
    </mat-menu>
</ng-container>